import { Suspense } from "react";
import { Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { Permissions } from "../../../util/Permissions";
import { CommercialPapersManagement } from "./CommercialPapers";

const CommercialPaperManagementPages = () => {
    return (
        <>
            <AsideMenu>
                <UserGroupMenu destination="/commercial-papers" />
            </AsideMenu>
            <Section>
                <Suspense fallback={<LayoutSplashScreen />}>
                    <Switch>
                        <ContentRoute path="/commercial-papers/:userGroup" permission={Permissions.SUBSCRIPTIONS} component={CommercialPapersManagement} />
                    </Switch>
                </Suspense>
            </Section>
        </>
    );
};

export default CommercialPaperManagementPages;
